import generalStore from './modules/general.store'
import projectsStore from './modules/projects.store'
import blogStore from './modules/blog.store'
import servicesStore from './modules/services.store'

// A Vuex instance is created by combining the state, the actions,
// and the mutations. Because the actions and mutations are just
// functions that do not depend on the instance itself, they can
// be easily tested or even hot-reloaded (see counter-hot example).

export default {
	modules: {
		general: generalStore,
		projects: projectsStore,
		blog: blogStore,
		services: servicesStore
	},
	strict: true
}



// WEBPACK FOOTER //
// ./src/vuex/store.js